<template>
  <form
    class="search_component_form"
    @submit.prevent
  >
    <input
      v-model="searchTerm"
      autocomplete="off"
      class="input_styles search_icon"
      :placeholder="placeholder"
      type="search"
    >
  </form>
</template>

<script>
import _ from 'lodash';
export default {
  props: {
    placeholder: {
      type: String,
      default: 'Search',
    },
    defaultValue: {
      type: String,
      default: undefined,
    },
  },
  emits: ['search'],
  data() {
    return {
      searchTerm: ''
    }
  },
  watch: {
    searchTerm: {
      handler() {
        this.throttle();
      }
    }
  },
  mounted() {
    if(this.defaultValue) {
      this.searchTerm = this.defaultValue;
    }
  },
  methods: {
    emitSearch() {
      this.$emit('search', this.searchTerm);
    },
    throttle: _.debounce(function () {
      this.emitSearch();
    }, 500)
  },
}
</script>

<style scoped>
.input_styles.search_icon {
  background-repeat: no-repeat;
  padding-left: 2.5rem;
  background-repeat: no-repeat;
  background-position: 16px center;
}

input[type='search'] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  appearance: textfield;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.search_icon {
  background-image: url("data:image/svg+xml,%3Csvg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.33337 13.8333C10.6471 13.8333 13.3334 11.147 13.3334 7.83334C13.3334 4.51963 10.6471 1.83334 7.33337 1.83334C4.01967 1.83334 1.33337 4.51963 1.33337 7.83334C1.33337 11.147 4.01967 13.8333 7.33337 13.8333Z' stroke='%23040707' stroke-width='1.33333' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M14.6667 15.1667L12 12.5' stroke='%23040707' stroke-width='1.33333' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
}

.input_styles {
  padding: 1rem;
  border-radius: 12px;
  background-color: #F7F5F2;
  height: 3rem;
  font-size: 14px;
  letter-spacing: -0.5px;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

input {
  line-height: normal;
}
</style>
